"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GetBucketMetricsConfigurationInput_1 = require("./GetBucketMetricsConfigurationInput");
var GetBucketMetricsConfigurationOutput_1 = require("./GetBucketMetricsConfigurationOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.GetBucketMetricsConfiguration = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "GetBucketMetricsConfiguration",
    http: {
        method: "GET",
        requestUri: "/{Bucket}?metrics"
    },
    input: {
        shape: GetBucketMetricsConfigurationInput_1.GetBucketMetricsConfigurationInput
    },
    output: {
        shape: GetBucketMetricsConfigurationOutput_1.GetBucketMetricsConfigurationOutput
    },
    errors: []
};
//# sourceMappingURL=GetBucketMetricsConfiguration.js.map